import React from 'react';
import classNames from 'classnames';

import LoaderSvg from './loader-svg.component';

export type LoaderProps = {} & React.SVGAttributes<SVGElement>;

export const Loader: React.FC<LoaderProps> = ({ ...props }) => {
  return <LoaderSvg {...props} className={classNames(props.className)} />;
};
